import React from 'react';
import { IconsPros } from './types';

/**
 * BringForward Icon component
 *
 * @returns JSX.ELEMENT
 */
export const BringForwardIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M12.46,4.67v6.55c0,1-.52,1.37-1.53,1.37H4.75v1.57c0,.51.11.61.77.61h8.3c.66,0,.77-.09.77-.61V5.28c0-.51-.11-.61-.77-.61ZM3.54,12.58H1.72c-1,0-1.53-.32-1.53-1.37V1.37C.19.32.71,0,1.72,0h9.22c1,0,1.53.32,1.52,1.37V3.43h1.36c1.28,0,2,.58,2,1.85v8.87c0,1.27-.7,1.85-2,1.85H5.52c-1.28,0-2-.58-2-1.85Z" />
    </svg>
  );
};
